import React, {Fragment} from "react";
import Loader from "../loader";
import { Link } from "react-router";
import HorseRacingGameDays from "../horseRacingGameDays";

export default function horseRacingCompetitionsTemplate () {
    const { data, loaded, params: { regionId, sportId } } = this.props;
    if (data && loaded) {
        const { selectedCompetitionId } = this.state;
        let newUrl = Number(sportId) === 31 ? "/horseRacing/" : '/greyhounds/';
        return <Fragment>
            <div className="mini-n-wrap">
                <div className="sports-navigation r-h-n">
                    <button className="sports-navigation-scroll-buttons left-button" onMouseDown={() => {
                        this.handleMouseUp();
                        this.scroll(this.refs.scroller, -3, 17);
                    }}/>
                    <div className="sport-nav-container-m" ref="scroller">
                        <div className="competitions-nav-l">
                            {
                                data.map(item =>
                                    <div className={`comp-s-item-v scrollable ${selectedCompetitionId === (item.id || -1).toString() ? "active" : ""}`} key={item.id}>
                                        <Link to={`${newUrl}${sportId}/${regionId}/${item.id}`} >{item.name}</Link>
                                </div>)
                            }
                        </div>
                    </div>
                    <button className="sports-navigation-scroll-buttons right-button" onMouseDown={() => {
                        this.handleMouseUp();
                        this.scroll(this.refs.scroller, 3, 17);
                    }}/>
                </div>
            </div>
            {selectedCompetitionId && <HorseRacingGameDays key={selectedCompetitionId} compId={selectedCompetitionId} competitionData={data}/>}
        </Fragment>;
    }
    return <Loader/>;
}